class ProductOffers extends HTMLElement {
  constructor() {
    super();

    this.codeElements = this.querySelectorAll('.product-offers__code');
    this.infoButtons = this.querySelectorAll('.offer-info-button');
    this.tooltips = this.querySelectorAll('.offer-tooltip');
    this.modal = this.querySelector('.offer-modal');
    this.modalContent = this.querySelector('.offer-modal__content');
    this.modalBody = this.querySelector('.offer-modal__body');
    this.modalClose = this.querySelector('.offer-modal__close');

    this.codeElements.forEach((codeElement) => {
      codeElement.addEventListener('click', () => {
        this.copyToClipboard(codeElement.textContent.trim());
        this.showCopiedMessage(codeElement);
      });
    });

    // Info button functionality
    this.infoButtons.forEach((button) => {
      const offerId = button.getAttribute('data-offer-id');
      const tooltip = this.querySelector(`#${offerId}`);

      // Desktop: Show tooltip on hover
      if (window.innerWidth >= 750) {
        button.addEventListener('mouseenter', () => {
          if (tooltip) {
            const buttonRect = button.getBoundingClientRect();
            tooltip.style.display = 'block';
            tooltip.style.top = `${buttonRect.bottom + 10}px`;
            tooltip.style.left = `${buttonRect.left - 100}px`;
          }
        });

        button.addEventListener('mouseleave', () => {
          if (tooltip) {
            tooltip.style.display = 'none';
          }
        });
      }

      // Mobile: Show modal on click
      button.addEventListener('click', () => {
        if (window.innerWidth < 750 && tooltip) {
          this.showModal(tooltip.innerHTML);
        }
      });
    });

    // Close modal
    if (this.modalClose) {
      this.modalClose.addEventListener('click', () => {
        this.hideModal();
      });
    }

    // Close modal when clicking outside content
    if (this.modal) {
      this.modal.addEventListener('click', (event) => {
        if (event.target === this.modal) {
          this.hideModal();
        }
      });
    }
  }

  copyToClipboard(text) {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    document.body.removeChild(textarea);
  }

  showCopiedMessage(element) {
    const originalText = element.textContent;
    element.textContent = 'Copied!';

    setTimeout(() => {
      element.textContent = originalText;
    }, 1500);
  }

  showModal(content) {
    if (this.modal && this.modalBody && this.modalContent) {
      this.modalBody.innerHTML = content;
      this.modal.classList.add('active');

      // Animate modal in
      setTimeout(() => {
        this.modalContent.style.transform = 'translateY(0)';
      }, 10);

      document.body.style.overflow = 'hidden';
    }
  }

  hideModal() {
    if (this.modal && this.modalContent) {
      this.modalContent.style.transform = 'translateY(100%)';

      // Wait for animation to complete before hiding modal
      setTimeout(() => {
        this.modal.classList.remove('active');
        document.body.style.overflow = '';
      }, 300);
    }
  }
}

if (!customElements.get('product-offers')) {
  customElements.define('product-offers', ProductOffers);
} 